import * as read_api from "./alan_api";
export function serialize($_client_protocol_request: read_api.Cclient_protocol_request) {
	const raw_data: Record<string, any> = {};
	{
		let raw_access_type: Record<string, any>;
		switch ($_client_protocol_request.properties.access_type.state.name) {
			case 'anonymous': {
				const $_anonymous = $_client_protocol_request.properties.access_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_access_type = raw_data
				break;
			}
			case 'authenticated': {
				const $_authenticated = $_client_protocol_request.properties.access_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["token"] = $_authenticated.properties.token;
				raw_access_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_protocol_request.properties.access_type.state)
		}
		raw_data["access type"] = [$_client_protocol_request.properties.access_type.state.name, raw_access_type];
	}
	{
		let raw_type: Record<string, any>;
		switch ($_client_protocol_request.properties.type.state.name) {
			case 'request': {
				const $_request = $_client_protocol_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["client token"] = $_request.properties.client_token.value;
				{
					let raw_type: Record<string, any>;
					switch ($_request.properties.type.state.name) {
						case 'authentication uri': {
							const $_authentication_uri = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'client query': {
							const $_client_query = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["request"] = $_client_query.properties.request;
							raw_type = raw_data
							break;
						}
						case 'mutation': {
							const $_mutation = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["request"] = $_mutation.properties.request;
							raw_type = raw_data
							break;
						}
						case 'report query': {
							const $_report_query = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["request"] = $_report_query.properties.request;
							raw_type = raw_data
							break;
						}
						case 'server time': {
							const $_server_time = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'subscribe': {
							const $_subscribe = $_request.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["subscription"] = $_subscribe.properties.subscription;
							raw_data["subscription id"] = $_subscribe.properties.subscription_id;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_request.properties.type.state)
					}
					raw_data["type"] = [$_request.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'unsubscribe': {
				const $_unsubscribe = $_client_protocol_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["subscription id"] = $_unsubscribe.properties.subscription_id;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_protocol_request.properties.type.state)
		}
		raw_data["type"] = [$_client_protocol_request.properties.type.state.name, raw_type];
	}
	return raw_data;
}